import * as React from 'react';
import {defineMessage} from 'react-intl';
import {BuildInstructions} from '../../components/left-col';

export const buildInstructions = [
  {
    label: 'Composer',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.php.composer.body',
        defaultMessage: 'Install the library:',
      }),
    },
    command: 'composer require stripe/stripe-php',
    shell: true,
  },
  {
    label: 'GitHub',
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.snippets.php.github.body',
        defaultMessage:
          'Or download the stripe-php library source code directly ',
        description:
          'First part of a sentence that ends in docsApp.ib.aap.snippets.php.github.link . Please translate them with this in mind.',
      }),
    },
    link: {
      href: 'https://github.com/stripe/stripe-php',
      label: {
        message: defineMessage({
          id: 'docsApp.ib.aap.snippets.php.github.link',
          defaultMessage: 'from GitHub.',
          description:
            'Second part of a sentence that begins in with docsApp.ib.aap.snippets.php.github.body . Please translate them with this in mind.',
        }),
      },
    },
  },
];

export const setup = {
  heading: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.php.setup.heading',
      defaultMessage: 'Install the Stripe PHP library',
    }),
  },
  body: {
    message: defineMessage({
      id: 'docsApp.ib.aap.snippets.php.setup.body',
      defaultMessage:
        'Install the library with composer and initialize with your secret API key. Alternatively, if you’re starting from scratch and need a composer.json file, download the files using the link in the code editor.',
    }),
  },
  Component() {
    return <BuildInstructions instructions={buildInstructions} />;
  },
};

export const run = 'php -S 127.0.0.1:4242 -docroot=public';
